"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var BestHR = _styledComponents["default"].div.attrs(function () {
  return {
    className: "my-3",
    id: "best-hr"
  };
}).withConfig({
  displayName: "BestTitle__BestHR",
  componentId: "sc-1upost4-0"
})(["width:100%;border-bottom:1px solid #d2d2d2;font-size:1rem;"]);
/**
 * Title component to display any children with an underline
 */

var BestTitle = function BestTitle(_ref) {
  var children = _ref.children;
  return _react["default"].createElement(BestHR, null, children);
};
BestTitle.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = BestTitle;
exports["default"] = _default;